import { __read, __spreadArray } from "tslib";
// https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder() {
        this.query = {};
        this.groupId = null;
    }
    QueryBuilder.prototype.withQuery = function (q) {
        Object.assign(this.query, q);
        return this;
    };
    QueryBuilder.prototype.addSort = function (fieldName, order) {
        if (order === void 0) { order = null; }
        if (fieldName) {
            this.query.sort = __spreadArray(__spreadArray([], __read((this.query.sort || [])), false), [{ fieldName: fieldName, order: order }], false);
        }
        return this;
    };
    QueryBuilder.prototype.addPaging = function (limit, offset) {
        if (offset === void 0) { offset = null; }
        if (limit) {
            this.query.paging = { limit: limit, offset: offset };
        }
        return this;
    };
    QueryBuilder.prototype.addFilter = function (filter) {
        if (filter) {
            this.query.filter = this.query.filter || {};
            Object.assign(this.query.filter, filter);
        }
        return this;
    };
    QueryBuilder.prototype.withGroupId = function (groupId) {
        if (groupId) {
            this.groupId = groupId;
        }
        return this;
    };
    QueryBuilder.prototype.build = function () {
        return { query: this.query, groupId: this.groupId };
    };
    return QueryBuilder;
}());
export { QueryBuilder };
//# sourceMappingURL=QueryBuilder.js.map